import { Command, Electron } from 'pos/common';
import { Result } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import { Permission, Res } from 'core/api';
import { Message } from 'core/ui-next/modal';

declare global {
	interface CommandType {
		runAdmin: () => Promise<Result>
	}
}

Command.register('runAdmin', Preconditions.ensure(Permission.Administration_Execute), async (): Promise<Result> => {
	if (!Electron.isEnabled()) {
		await Message.show(Res.Msg.MSG_ELECTRON_IS_REQUIRED_TO_RUN_ADMIN_WINDOW());
		return Result.error();
	}
	await Electron.ProcessManager.runAdmin();
	return Result.ok();
});